import dataService from "../../api";
import { serverErrorMessage, showAlert, catchHandler } from "../../utils/helpers";


const state = {
    nationalities: [],
    banks: [],
    branches: [],
    administrations: [],
    departments: [],
    jobs: [],
    lookups: [],
    jobGrades: [],
    specialties: [],
    universities: [],
    jobGroups: [],
    municipalities: [],
    vacationsTypes: [],
    units: [],
    allDepartments: [],
    assignments: [],
    appointmentTypes: [],
    filteredJobGrades: [],
    localities: [],
};

const getters = {
    getLookupByType: state => lookupType => state.lookups.filter((lookup) => lookup.type == lookupType),
    getUniversityByType: state => type => state.universities.filter((x) => x.type == type)

};

const mutations = {
    setLookups: (state, t) => (state.lookups = t),
    setNationalities: (state, t) => (state.nationalities = t),
    setBanks: (state, banks) => (state.banks = banks),
    setBranches: (state, branches) => (state.branches = branches),
    setAdministrations: (state, administrations) => (state.administrations = administrations),
    setDepartments: (state, departments) => (state.departments = departments),
    setJobs: (state, jobs) => (state.jobs = jobs),
    setJobGrades: (state, jobGrades) => (state.jobGrades = jobGrades),
    setFilteredJobGrades: (state, filteredJobGrades) => (state.filteredJobGrades = filteredJobGrades),
    setSpecialties: (state, specialties) => (state.specialties = specialties),
    setUniversities: (state, universities) => (state.universities = universities),
    setJobGroups: (state, jobGroups) => (state.jobGroups = jobGroups),
    setMunicipalities: (state, municipalities) => (state.municipalities = municipalities),
    setVacationsTypes: (state, vacationsTypes) => (state.vacationsTypes = vacationsTypes),
    setUnits: (state, units) => (state.units = units),
    setAllDepartments: (state, departments) => (state.allDepartments = departments),
    setAssignments: (state, assignments) => (state.assignments = assignments),
    setAppointmentTypes: (state, appointmentTypes) => (state.appointmentTypes = appointmentTypes),
    setLocalities: (state, localities) => (state.localities = localities),
};

const actions = {

    async getLookups({ commit }) {
        try {
            const response = await dataService.lookups.getLookups();

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            const lookups = response.data.lookups;
            commit("setLookups", lookups);

        } catch (error) {
            catchHandler(error);
        }
    },
    async getNationalities({ commit }) {
        try {
            const response = await dataService.lookups.getNationalities();

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            const nationalities = response.data.nationalities;
            commit("setNationalities", nationalities);

        } catch (error) {
            catchHandler(error);
        }
    },
    async getBranches({ commit }) {
        try {
            const response = await dataService.lookups.getBranches();
            commit("setBranches", response.data.branches);
        } catch (error) {
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getBanks({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getBanks();
            // stopLoading();

            const banks = response.data.banks;
            commit("setBanks", banks);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getAdministrations({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getAdministrations();
            // stopLoading();

            const administrations = response.data.administrations;
            commit("setAdministrations", administrations);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getDepartments({ commit }, administrationId) {
        try {
            // startLoading();
            const response = await dataService.lookups.getDepartments(administrationId);
            // stopLoading();

            const departments = response.data.departments;
            commit("setDepartments", departments);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getJobs({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getJobs();
            // stopLoading();
            // 
            const jobs = response.data.jobs;
            commit("setJobs", jobs);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getJobsByGroup({ commit }, id) {
        try {
            // startLoading();
            const response = await dataService.lookups.getJobsByGroup(id);
            // stopLoading();

            const jobs = response.data.jobs;
            commit("setJobs", jobs);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getJobGrades({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getJobGrades();
            // stopLoading();

            const jobGrades = response.data.jobGrades;
            commit("setJobGrades", jobGrades);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getAdministrationsByType({ commit }, id) {
        try {
            // startLoading();
            const response = await dataService.lookups.getAdministrationsByType(id);
            // stopLoading();

            const administrations = response.data.administrations;
            commit("setAdministrations", administrations);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getManagementEmployees(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            // startLoading()
            const response = await dataService.lookups.getManagementEmployees(paramsString);
            // stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);
        } catch (error) {
            // stopLoading()
            catchHandler(error);
        }
    },
    async getSpecialties({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getSpecialties();
            // stopLoading();

            const specialties = response.data.specialties;
            commit("setSpecialties", specialties);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getUniversities({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getUniversities();
            // stopLoading();

            const universities = response.data.universities;
            commit("setUniversities", universities);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },

    async employeesSearch(_, employeeNo) {
        try {

            // startLoading()
            const response = await dataService.lookups.employeesSearch(employeeNo);
            // stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data.employee);

        } catch (error) {
            // stopLoading()
            catchHandler(error);
        }
    },

    async getJobGroups({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getJobGroups();
            // stopLoading();

            const jobGroups = response.data.jobGroups;
            commit("setJobGroups", jobGroups);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getMunicipalities({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getMunicipalities();
            // stopLoading();

            const municipalities = response.data.municipalities;
            commit("setMunicipalities", municipalities);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getVacationsTypes({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getVacationsTypes();
            // stopLoading();

            const vacationsTypes = response.data.vacationsTypes;
            commit("setVacationsTypes", vacationsTypes);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getUnits({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getUnits();
            // stopLoading();

            const units = response.data.units;
            commit("setUnits", units);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getAllDepartments({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getAllDepartments();
            // stopLoading();

            const departments = response.data.departments;
            commit("setAllDepartments", departments);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getAssignments({ commit }, id) {
        try {
            // startLoading();
            const response = await dataService.lookups.getAssignments(id);
            // stopLoading();

            const assignments = response.data.assignments;
            commit("setAssignments", assignments);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getjobGradesByAdminId({ commit }, id) {
        try {
            // startLoading();
            const response = await dataService.lookups.getjobGradesByAdminId(id);
            // stopLoading();

            const jobGrades = response.data.jobGrades;
            commit("setFilteredJobGrades", jobGrades);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },

    async getUnitsById({ commit }, { id, typeId }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getUnitsById(id, typeId);
            // stopLoading();

            const units = response.data.units;
            commit("setUnits", units);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getEmployees(_, params) {
        try {
            const paramsString = Object.entries(params)
                .filter(([, val]) => val !== null)
                .map(([key, val]) => `${key}=${val}`)
                .join("&");
            //    startLoading()
            const response = await dataService.lookups.getEmployees(paramsString);
            // stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }
            return Promise.resolve(response.data.employees);

            // commit("setUsers", response.data.users);


        } catch (error) {
            //   stopLoading()
            catchHandler(error);
        }
    },
    async getEmployeesByAssignment() {
        try {

            // startLoading()
            const response = await dataService.lookups.getEmployeesByAssignment();
            // stopLoading()

            if (!response.data.statusCode) {
                showAlert(serverErrorMessage);
                return;
            }

            return Promise.resolve(response.data);
        } catch (error) {
            // stopLoading()
            catchHandler(error);
        }
    },
    async getJobGradesForAdministratives({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getJobGradesForAdministratives();
            // stopLoading();

            const jobGrades = response.data.jobGrades;
            commit("setJobGrades", jobGrades);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    }, async getAppointmentTypes({ commit }) {
        try {
            // startLoading();
            const response = await dataService.lookups.getAppointmentTypes();
            // stopLoading();

            const appointmentTypes = response.data.appointmentTypes;
            commit("setAppointmentTypes", appointmentTypes);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
    async getLocalities({ commit }, id) {
        try {
            // startLoading();
            const response = await dataService.lookups.getLocalities(id);
            // stopLoading();

            const localities = response.data.localities;
            commit("setLocalities", localities);
        } catch (error) {
            // stopLoading();
            const err = error.response.data;
            alert.alert(`${err.message} [${err.statusCode}]`, "warning");
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};